export enum ChannelType {
  LOCAL_QUEUE,
  LOCAL_TOPIC,
  DISTRIBUTED_QUEUE,
  DISTRIBUTED_TOPIC,
}

export namespace ChannelType {
  let elements = [
    ChannelType.LOCAL_QUEUE,
    ChannelType.LOCAL_TOPIC,
    ChannelType.DISTRIBUTED_QUEUE,
    ChannelType.DISTRIBUTED_TOPIC,
  ];
  let alias = "com.bcdfx.service.messaging.api.ChannelType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
